export default __webpack_public_path__ + "static/media/analyticicon.cd8efe5b.svg";